import { render, staticRenderFns } from "./edit-button.vue?vue&type=template&id=76a06fa9&scoped=true"
import script from "./edit-button.vue?vue&type=script&lang=js"
export * from "./edit-button.vue?vue&type=script&lang=js"
import style0 from "./edit-button.vue?vue&type=style&index=0&id=76a06fa9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a06fa9",
  null
  
)

export default component.exports